module.exports = __webpack_public_path__ + "static/media/inf_21og22.6c54e70f.mp3";